module.exports = __webpack_public_path__ + "media/pro/Google-bd9edbb3.png";